import { useAppSelector } from '~publish/legacy/store'
import AppStore from '../../stores/AppStore'
import { getFormattedWhatPreventsSavingMessages } from '../update-saver/utils'
import { selectContentGenerationStatus } from '~publish/legacy/ai/state/slice'
import { useMemo } from 'react'

export function usePostValidation(): {
  isSavePostDisabled: boolean
  isSaveDraftDisabled: boolean
  postValidationIssues: Array<React.ReactElement | string> | null
  draftValidationIssues: Array<React.ReactElement | string> | null
} {
  const {
    whatPreventsSaving,
    whatPreventsSavingDraft,
    isSavingDraftPossible,
    isSavingPossible,
  } = AppStore.getAppState()

  const { contentGenerationInProgress } = useAppSelector((state) =>
    selectContentGenerationStatus(state),
  )

  return useMemo(() => {
    const postValidationIssues = contentGenerationInProgress
      ? ['Generating content...']
      : getFormattedWhatPreventsSavingMessages({
          warningMessages: whatPreventsSaving,
        })

    const draftValidationIssues = contentGenerationInProgress
      ? ['Generating content...']
      : getFormattedWhatPreventsSavingMessages({
          warningMessages: whatPreventsSavingDraft,
        })

    return {
      isSavePostDisabled: !isSavingPossible,
      isSaveDraftDisabled: !isSavingDraftPossible,
      postValidationIssues,
      draftValidationIssues,
    }
  }, [
    contentGenerationInProgress,
    whatPreventsSavingDraft,
    whatPreventsSaving,
    isSavingPossible,
    isSavingDraftPossible,
  ])
}
